import { isLoggedInGuard, NavigationComponent, UnityCoreAppRoutes, UnityCoreRoutes, UnityModalPopupComponent } from '@unity/core-components-lib'
import { MarketMessengerRoutes } from '@unity/market-messenger-core-lib'
import { UnityMessengerRoutes, UnityMessengerModalRoutes } from '@unity/unity-messenger-core-lib'
import { UnityAuthUiManagementRoutes } from '@unity/auth-management-ui-lib'
import { loginRoutes } from '@unity/core-login-lib';
import { UnityRoutes } from '@unity/core-models-lib';
import { MessengerVaultModalRoutes, MessengerVaultRoutes } from '@unity/message-vault-core-lib';

export const UnityCoreUiRoutes: UnityRoutes = [
  ...loginRoutes,
  ...UnityCoreRoutes,
  {
    path: "popup",
    component: UnityModalPopupComponent,
    outlet: "unitymodal",
    children: [
      ...MessengerVaultModalRoutes,
      ...UnityMessengerModalRoutes
    ]
  },
  {
    path: 'apps',
    component: NavigationComponent,
    canActivate: [isLoggedInGuard],
    canActivateChild: [isLoggedInGuard],
    children:[
      ...UnityCoreAppRoutes,
      ...MarketMessengerRoutes,
      ...UnityMessengerRoutes,
      ...UnityAuthUiManagementRoutes,
      ...MessengerVaultRoutes
    ]
  },
]; 

